<script>
/**
 * This mixin provides unique id
 * It's not meant to be used directly.
 *
 * @mixin
 */
import { v4 as uuidv4 } from 'uuid';
export default {
    beforeCreate () {
        this.uid = uuidv4();
    }
};
</script>
